// extracted by mini-css-extract-plugin
export default {"melodyVideo":"AP-z","isFullWidth":"BP-z","landingPageVideo":"CP-z","play":"DP-z","iframeVideo":"EP-z","playHidden":"FP-z","fullwidth":"GP-z"};